import { checkIsSportUser } from "./trackingQueryHook.js";
import { APP_SERVER_URL, APP_WINPOT_CASINO } from "../../../config";

const getSiteConfig = async (type) => {
	const params = new URLSearchParams({ type });
	try {
		const response = await fetch(`${APP_SERVER_URL}site/config?${params}`);
		return await response.json();
	} catch (error) {
		throw new Error('Error:', error);
	}
};

const getLinkFromAppsFlyer = (isSportUser = false) => {
	//Initializing Smart Script arguments
	const oneLinkURL = isSportUser ? "https://sport-web-to-app.onelink.me/b6kl" : "https://casino-web-to-app.onelink.me/tHKs";
	const mediaSource = {keys:["utm_source"],defaultValue:"utm_source"};
	const afSub1 = {keys:["affiliateId"]};
	const afSub2 = {keys:["subId"]};
	const afSub3 = {keys:["sourceId"]};
	const af_offer = {paramKey:"af_offer",keys:["offer"]};
	const af_var1 = {paramKey:"af_var1",keys:["var1"]};
	const af_var2 = {paramKey:"af_var2",keys:["var2"]};
	const af_var3 = {paramKey:"af_var3",keys:["var3"]};
	const af_var4 = {paramKey:"af_var4",keys:["var4"]};
	const af_var5 = {paramKey:"af_var5",keys:["var5"]};
	const custom_ss_ui = {paramKey:"af_ss_ui",defaultValue:"true"};

	//Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
	//Onelink URL is generated.
	const result = window.AF_SMART_SCRIPT?.generateOneLinkURL({
		oneLinkURL: oneLinkURL,
		afParameters: {
			mediaSource: mediaSource,
			afSub1: afSub1,
			afSub2: afSub2,
			afSub3: afSub3,
			afCustom: [
				af_offer,
				af_var1,
				af_var2,
				af_var3,
				af_var4,
				af_var5,
				custom_ss_ui
			]
		}
	});

	return result;
};

export const openAppLink = (needLinkForIOSApp = true) => {
	const isSportUser = checkIsSportUser();
	if (needLinkForIOSApp) {
		const linkFromAppsFlyer = getLinkFromAppsFlyer(isSportUser);
		if (linkFromAppsFlyer && linkFromAppsFlyer.clickURL) {
			window.open(linkFromAppsFlyer.clickURL, '_blank');
		} else {
			const link = isSportUser
				? 'https://apps.apple.com/mx/app/winpot-sport/id6446956929'
				: 'https://apps.apple.com/mx/app/winpot-casino/id1632635281';
			window.open(link, '_blank');
		}
	} else {
		if (isSportUser) {
			const linkFromAppsFlyer = getLinkFromAppsFlyer(isSportUser);
			if (linkFromAppsFlyer && linkFromAppsFlyer.clickURL) {
				window.open(linkFromAppsFlyer.clickURL, '_blank');
			} else {
				const link = 'https://play.google.com/store/apps/details?id=com.datawise.wpmain&pli=1';
				window.open(link, '_blank');
			}
		} else {
			window.location.href = `${APP_WINPOT_CASINO}app`;
			// localStorage.setItem('isAppPanelVisible', Date.now().toString()); Mobile App Banner is unused on home page
		}
	}
};
